<template>
  <div class="DropdownMenu" v-click-outside ref="scrollParent">
    <button
      ref="button"
      :class="['DropdownMenu__Label', stylings.labelButtonClass]"
      @click.stop.prevent="toggleMenu()"
    >
      <slot name="label"></slot>
      <slot name="icon">
        <i
          :class="[
            'fa',
            'fa-angle-down',
            'DropdownMenu__Arrow',
            isDropped ? 'DropdownMenu__Arrow--Flipped' : '',
          ]"
        ></i>
      </slot>
    </button>
    <div
      class="DropdownMenu__List"
      ref="dropdown"
      :class="{ 'DropdownMenu__List--Visible': isDropped }"
    >
      <slot name="dropdown"></slot>
    </div>
  </div>
</template>

<script>
import DropdownMixin from "./../mixins/dropdown";

export default {
  name: "DropdownMixin",
  mixins: [DropdownMixin],
};
</script>

<style lang="scss">
@import "~@/scss/variables";
@import "~@/scss/mixins";

.DropdownMenu {
  margin-right: 3rem;
  display: inline-block;
  position: relative;
  font-size: 16px;
  cursor: pointer;
  text-align: left;

  &:hover .DropdownMenu__Arrow {
    color: $color-primary;
  }
  @include breakpoint-manual(max-width, $break-small) {
    margin-right: 2rem;
  }
  @include breakpoint-manual(max-width, $break-extra-small) {
    margin-right: 0.5rem;
  }
}

.DropdownMenu__Label {
  color: #fff;
  user-select: none;
}

.DropdownMenu__Arrow {
  margin-left: 8px;
  transition: transform 0.2s;

  &--Flipped {
    transform: rotate(180deg);
  }
}

.DropdownMenu__List {
  display: none;
  background: #fff;
  color: initial;
  border-radius: 5px;
  box-shadow: 0 1px 4px 2px rgba(34, 37, 72, 0.12);
  z-index: 500;
  padding: 8px 0;
  position: absolute;
  top: calc(100% + 10px);
  right: -10px;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;

  &--Visible {
    display: block;
  }

  @include breakpoint-manual(max-width, $break-small - 1px) {
    right: 0;
  }
}
</style>
